import { selectorFamily } from "recoil";
import { layerDefsAtomFamily } from "../layerDefsAtoms";

export const layerRequiresGis2TokenSelector = selectorFamily({
  key: "layer-requires-gis-2-token",
  get: 
    (layerID) =>
    ({ get }) => {
      const layerDef = get(layerDefsAtomFamily(layerID));
      return Boolean(layerDef?.requiresGis2Token);
    },
});
